import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { DashboardCategory } from '../../constants/DashboardConf'
import DashboardSetting from '../DashboardSetting/DashboardSetting'
import { useSelector } from 'react-redux'
import { fetchConsumerDetail } from '../../apis/consumer360'

function ConsumerDetail (props) {
  const { goBackPath } = props
  const location = useLocation()
  const { state } = location || {}
  const { data } = state || {}
  const user = useSelector(state => state.user)
  const { nowBrand, brands } = user || {}
  const nowBrandData = brands?.find(item => item.id === nowBrand)
  const [content, setContent] = useState({})

  const getData = async () => {
    const res = await fetchConsumerDetail(nowBrand, data?.consumerId)
    if (res?.status === 200) setContent(res?.data)
  }
  useEffect(() => {
    getData()
  }, [])

  return (
    <DashboardSetting
      goBackPath={goBackPath}
      fixedData={nowBrandData}
      type={DashboardCategory.CONSUMER}
      content={content}
      renderBasedOnStatus
    />
  )
}

export default ConsumerDetail
